import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {useCallback, useState} from 'react';
import {useLocation} from 'react-router';

import history from '../../../../../util/history';
import {useDebouncedValue} from '../../../../../util/useDebouncedValue';
import {getTitleFromConfig} from '../../../../PanelMediaBrowser/utils/getTitleFromConfig';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';
export const ChartTitle = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const {chartTitle: _, ...configWithoutChartTitle} = config;
  const defaultChartTitle = getTitleFromConfig(configWithoutChartTitle);

  // Debounce the updateConfig call while the user is typing
  const updateChartTitle = useCallback(
    (chartTitle: string) => {
      const panelDisplayName = searchParams.get('panelDisplayName');
      if (chartTitle === '') {
        unsetConfigField('chartTitle');
        // Update the URL for the panel display name if on a specific run page
        if (panelDisplayName && panelDisplayName !== defaultChartTitle) {
          searchParams.set('panelDisplayName', defaultChartTitle);
          history.replace(`${location.pathname}?${searchParams.toString()}`);
        }
      } else {
        updateConfig({chartTitle});

        // Update the URL for the panel display name if on a specific run page
        if (panelDisplayName && panelDisplayName !== chartTitle) {
          searchParams.set('panelDisplayName', chartTitle);
          history.replace(`${location.pathname}?${searchParams.toString()}`);
        }
      }
    },
    // If we rely on searchParams, updateConfig will be called on every keystroke
    // because the useCallback will be regenerated and break the debouncing
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateConfig, location.pathname, unsetConfigField, defaultChartTitle]
  );
  const {
    value: configChartTitle,
    debouncedSetValue: debouncedUpdateChartTitle,
  } = useDebouncedValue(config.chartTitle ?? '', 2000, updateChartTitle);

  // this state is needed to control the input field - it is updated with every keystroke
  const [chartTitle, setChartTitle] = useState(configChartTitle);

  return (
    <div className="flex flex-col">
      <SettingTitle
        title="Panel title"
        configField="chartTitle"
        unsetConfigField={() => {
          setChartTitle('');
          debouncedUpdateChartTitle('');
        }}
      />
      <TextField
        dataTest="media-chart-title-input"
        value={chartTitle}
        onChange={newValue => {
          setChartTitle(newValue);
          debouncedUpdateChartTitle(newValue);
        }}
      />
    </div>
  );
};
